// Whether a click on a link launcher opens its dialog. A modified or
// non-primary click, or one another handler took, follows the link instead.
export function shouldLaunch(event) {
  return (
    !event.defaultPrevented &&
    event.button === 0 &&
    !event.metaKey &&
    !event.ctrlKey &&
    !event.shiftKey &&
    !event.altKey
  );
}
